export const MAX_ALFRED_INDEXED_STRING_LENGTH = 100

export function countUnicodeCodePoints(value: string): number {
  return Array.from(value).length
}

export function getAlfredMaxLengthError(
  fieldLabel: string,
  value: string,
): string | undefined {
  if (countUnicodeCodePoints(value) <= MAX_ALFRED_INDEXED_STRING_LENGTH) return undefined
  return `${fieldLabel} cannot be longer than ${MAX_ALFRED_INDEXED_STRING_LENGTH} characters`
}
